import {SetGetListTournament} from './thunk/setGetListTournament';
import {SetGetSearchGame} from './thunk/setGetSearchGame';
import {SetGetViewTournament} from './thunk/setGetViewTournament';
import {SetGetViewTournamentStat} from './thunk/setGetViewTournamentStat';
import {SetPostCreateTournament} from './thunk/setPostCreateTournament';
import {SetPostCreateUser} from './thunk/setPostCreateUser';
import {SetPostIssueTournament} from './thunk/setPostIssueTournament';
import {SetPostUpdatePoints} from './thunk/setPostUpdatePoints';
import {SetPostUpdateTournament} from './thunk/setPostUpdateTournament';

export const Thunks = {
    SetGetListTournament,
    SetGetSearchGame,
    SetGetViewTournament,
    SetGetViewTournamentStat,
    SetPostCreateTournament,
    SetPostCreateUser,
    SetPostIssueTournament,
    SetPostUpdatePoints,
    SetPostUpdateTournament
}